import $ from 'jquery';

export default function handleMenus(e) {
    const links = Array.from( document.querySelectorAll( '.book-now-container .book-now-btn, .menu-wrapper a[href^="#"]') );
    let target = e.currentTarget.href;
    let idTarget = target.substring( target.lastIndexOf( '/' ) + 1 );

     links.map( link => {
        e.preventDefault();
        scrollTo( idTarget );
        handleCloseMenu();

        return true;
    } )
}

export function scrollTo( id, duration = 600 ) {
    const scrollDest = $( id ).offset().top;
    const isMobile = window.matchMedia( '(max-width: 980px)' ).matches;

    $( 'html, body').animate( {
		scrollTop: ( isMobile ) ? scrollDest - 100 : scrollDest - 220
	}, { duration, queue: false } );
}

export function handleCloseMenu() {
    let menu = document.querySelector( '.mobile-menu' );
    menu.classList.remove( 'active' );
}


